import Scrollbar from '@/components/scrollbar/scrollbar.vue'
import { numberWithSeparator } from '@/utils/format-strings'

export default {
  name: 'FuelMoney',
  props: {
    /**
     * {
     *   fuel_money_transactions_list: Array<{
     *     transaction_id: number,
     *     datetime_created: string,
     *     amount: number,
     *     courier: { courier_id: number, first_name: string, last_name: string, native: boolean }
     *   }>,
     *   fuel_money_transactions_sum: number
     * }
     */
    fuelMoneyTransactions: {
      type: Object,
      required: true
    }
  },
  components: {
    Scrollbar
  },
  methods: {
    getCourierName(courier) {
      return `${courier.last_name} ${courier.first_name.charAt(0).toUpperCase()}.`
    },
    getFormatedSumm(summ) {
      return `${numberWithSeparator(summ)} ₽`
    }
  }
}